<template>
    <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
        <a-form-item label="关键字">
            <a-input v-model="searchP.keyword" placeholder="商户号/商户名称"></a-input>
        </a-form-item>


        <a-form-item label="签名作用域">
            <a-select name="" v-model="searchP.signtype" style="width:100px;">
                <a-select-option  value="">全部</a-select-option>
                <a-select-option  value="1">商户签名</a-select-option>
                <a-select-option  value="2">服务商签名</a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item label="审核状态">
            <a-select name="" v-model="searchP.signstatus" style="width:100px;">
                <a-select-option  value="">全部</a-select-option>
                <a-select-option  value="0">审核中</a-select-option>
                <a-select-option  value="1">审核通过</a-select-option>
                <a-select-option  value="2">审核失败</a-select-option>

            </a-select>
        </a-form-item>
        <a-form-item label="开始时间">
            <a-date-picker v-model="searchP.starttime" :show-time="{ format: 'YYYY-MM-DD HH:mm:ss' }"
                            format="YYYY-MM-DD HH:mm:ss" placeholder="选择开始时间"/>
        </a-form-item>
        <a-form-item label="结束时间">
            <a-date-picker v-model="searchP.endtime" :show-time="{ format: 'YYYY-MM-DD HH:mm:ss' }"
                            format="YYYY-MM-DD HH:mm:ss" placeholder="选择结束时间"/>
        </a-form-item>

        <a-form-item>
            <a-button type="primary" @click="handleSubmit">查询</a-button>
        </a-form-item>
    </a-form>
</template>

<script>

export default {
    components:{
    },
    data(){
        return {
            form: this.$form.createForm(this),
            searchP:{
                keyword:'',
                signtype:'',
                signstatus:'',
                starttime:'',
                endtime:'',
            }
        }
    },
    methods:{
        handleSubmit(){
            this.$emit("handleSearch",this.searchP);
        },
      
    },
    mounted(){
        this.handleSubmit();
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

